'use strict';

const { h } = require('phy');
const { Translate } = require('@grpn/preact-l10n');

const OfferLifestyleImage = require('../../modules/shared/views/offer/offer-lifestyle-image');
const MerchantLogoImage = require('../../modules/shared/views/merchants/merchant-logo-image');
const OfferRedemptionText = require('../../modules/shared/views/offer/offer-redemption-text');

const { getButtonUrl } = require('../../modules/support/slug-helper');

function getOfferImageSize(isTouch, cardWidth) {
  if (isTouch) {
    return cardWidth ? [`w_${cardWidth},h_126,c_fill`] : ['w_320,h_126,c_fill'];
  }

  return ['w_868,h_289'];
}

function getLogoImageSize(isTouch) {
  if (isTouch) {
    return { width: 84, height: 84 };
  }

  return { width: 108, height: 108 };
}

function Card({
  routes,
  item,
  className,
  sizes = {},
  child = null,
  tag = 'a',
  lazy = false,
}) {
  if (!item) return null;

  const {
    merchantSlug,
    destination,
    isExclusive,
    merchantName,
    offerCallout,
    advertName,
    description,
    offerTitle,
    media,
    offerId,
    offerType,
  } = item;

  const altText = `${merchantName} - ${offerCallout}`;

  const buttonUrl = getButtonUrl({
    routes,
    merchantSlug,
    destination,
  });

  const title = offerTitle || description || advertName;

  return h(
    `${tag}.${className}`,
    {
      href: buttonUrl,
      target: !merchantSlug && '_blank',
      title,
    },
    [
      h(
        '.logo',
        OfferLifestyleImage({
          alt: altText,
          data: media,
          size: sizes.offer,
          lazyload: lazy,
        })
      ),
      h(
        '.fade-banner',
        MerchantLogoImage({
          className: 'merchant-logo',
          data: media,
          alt: altText,
          size: sizes.logo,
          lazyload: lazy,
        }),
        h(`.description${isExclusive ? '.icon-logo-g' : ''}`, [
          isExclusive &&
            h(Translate, { tag: 'strong' }, 'js.modules.shared.Exclusive'),
          title,
        ]),
        className === 'carousel-card' &&
          offerId &&
          h('.coupon-button', OfferRedemptionText({ type: offerType }))
      ),
      child,
    ]
  );
}

module.exports = Card;
module.exports.getOfferImageSize = getOfferImageSize;
module.exports.getLogoImageSize = getLogoImageSize;
